import { AlertTriangle, Copy, MessageCircle, CreditCard, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { COMMERCIAL, formatPriceLabel } from "@/config/commercial";

export default function SubscriptionExpired({ business }) {
  const clabe = "014700605871854532";
  const mpLink = "https://mpago.la/1BeieKF";
  const wa = "527297553698";
  const msg = encodeURIComponent(
    `Hola, envío comprobante de pago de suscripción ${COMMERCIAL.planName} del negocio ${business?.name || ""}`
  );

  const copyClabe = () => {
    navigator.clipboard.writeText(clabe);
    toast.success("CLABE copiada");
  };

  return (
    <div
      data-testid="subscription-expired-screen"
      className="fixed inset-0 z-50 bg-void grain flex items-center justify-center p-6"
    >
      <div className="max-w-lg w-full bg-surface gold-border rounded-2xl p-8 relative animate-fade-up">
        <div className="w-14 h-14 rounded-full bg-neonpink/15 border border-neonpink/40 flex items-center justify-center mb-6">
          <AlertTriangle className="w-7 h-7 text-neonpink" strokeWidth={1.5} />
        </div>
        <p className="overline text-neonpink mb-3">Suscripción vencida</p>
        <h1 className="font-display text-3xl md:text-4xl leading-tight mb-3">
          Continúa usando <span className="text-gold">{COMMERCIAL.planName}</span>
        </h1>
        <div className="flex items-baseline gap-2 mb-4">
          <Sparkles className="w-5 h-5 text-gold" strokeWidth={1.5} />
          <span className="font-display text-2xl">{formatPriceLabel()}</span>
        </div>
        <p className="text-neutral-400 mb-6 text-sm leading-relaxed">
          Todo tu negocio seguirá disponible al activar tu suscripción. Transfiere con los datos abajo y envía el comprobante por WhatsApp, o paga en línea con Mercado Pago.
        </p>

        <div className="space-y-3">
          <div className="bg-void/60 border border-gold/15 rounded-xl p-4 flex items-center justify-between gap-3">
            <div className="min-w-0">
              <div className="overline mb-1">CLABE</div>
              <div className="font-mono text-sm truncate">{clabe}</div>
            </div>
            <Button
              size="sm"
              variant="ghost"
              className="text-cyan hover:text-gold"
              onClick={copyClabe}
              data-testid="copy-clabe-btn"
            >
              <Copy className="w-4 h-4 mr-1" /> Copiar
            </Button>
          </div>

          <a
            href={`https://wa.me/${wa}?text=${msg}`}
            target="_blank"
            rel="noreferrer"
            data-testid="whatsapp-comprobante-btn"
            className="block"
          >
            <Button className="w-full bg-gold text-void hover:bg-gold/90 font-bold rounded-full" size="lg">
              <MessageCircle className="w-4 h-4 mr-2" /> Administrar suscripción por WhatsApp
            </Button>
          </a>

          <a href={mpLink} target="_blank" rel="noreferrer" data-testid="mercadopago-link" className="block">
            <Button variant="outline" className="w-full border-cyan/40 text-cyan hover:bg-cyan/10 rounded-full" size="lg">
              <CreditCard className="w-4 h-4 mr-2" /> Pagar con Mercado Pago
            </Button>
          </a>
        </div>

        <p className="text-[11px] tracking-widest uppercase text-neutral-600 mt-6 text-center">
          Contacto: +52 729 755 3698
        </p>
      </div>
    </div>
  );
}
